module.exports = require("lodash/reduce");


//////////////////
// WEBPACK FOOTER
// external "lodash/reduce"
// module id = 128
// module chunks = 0 1